import { module } from 'modujs';

export default class DownloadFile extends module {

    static get settings() {
        return {
            LOADING_CLASS: 'is-loading',
            SUCCESS_CLASS: 'is-success',
            ERROR_CLASS: 'is-error',
        }
    }

    constructor(m) {
        super(m);

        this.url = this.getData('url')
        this.filename = this.getData('name') || 'merrell-archive'
    }

    init() {
        this.el.addEventListener('click', this.onClick = () => this.download())
    }

    download() {
        this.el.classList.add(DownloadFile.settings.LOADING_CLASS)

        fetch(this.url)
            .then(r => r.blob())
            .then(data => {
                const a = document.createElement('a');
                a.href = window.URL.createObjectURL(data);
                a.download = this.filename;
                a.click();

                this.el.classList.remove(DownloadFile.settings.LOADING_CLASS)
                this.el.classList.add(DownloadFile.settings.SUCCESS_CLASS)

                setTimeout(() => {
                    this.el.classList.remove(DownloadFile.settings.SUCCESS_CLASS)
                }, 2000);
            })
            .catch(e => {
                console.log(e)
                this.el.classList.remove(DownloadFile.settings.LOADING_CLASS)
                this.el.classList.add(DownloadFile.settings.ERROR_CLASS)

                setTimeout(() => {
                    this.el.classList.remove(DownloadFile.settings.ERROR_CLASS)
                }, 2000);
            });
    }

    destroy() {
        this.el.removeEventListener('click', this.onClick)
    }
}
